import * as ActionTypes from './actionTypes.js';
import extend from 'lodash/extend';

const initialState = {
  references: [],
  showLoginPopUP: false,
  isResetIdleTimeout: false,
  isSessionExpiredMessage: false,
  showInValidUserPopUP: false,
  showActiveTabPopup: false,
};

export default function s2sReducers(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_PORTAL_REFERENCE:
    case ActionTypes.SHOW_LOGIN_POPUP:
      return extend({}, state, action.payload);
    case ActionTypes.RESET_IDLE_TIMEOUT:
      return extend({}, state, action.payload);
    case ActionTypes.SHOW_SESSION_EXPIRY_MESSAGE:
      return extend({}, state, action.payload);
    case ActionTypes.SHOW_DIFF_USER_POPUP:
      return extend({}, state, action.payload);
    case ActionTypes.SHOW_ACTIVE_TAB_POPUP:
      return extend({}, state, action.payload);
    default:
      return state;
  }
}
